module.exports = __webpack_public_path__ + "static/media/IUP_zast_L1.311d1494.svg";